import Lang from './Lang';

export default Lang;
